<p-toast position="top-right"></p-toast>

<div *ngIf="isLoading" class="spinner">
  <p>Loading data...</p>
</div>

<!-- Stats Cards -->
<div
  class="main-content"
  *ngIf="!isLoading"
  [ngClass]="{ 'collapsed-content': sidebarCollapsed, 'expanded-content': !sidebarCollapsed }"
>
  <div class="row g-3">
    <div class="col-md-4 col-lg-4">
      <div class="stat-card">
        <div>
          <h5>{{ dashboardData.totalCallers || 0 }}</h5>
          <p>{{ 'DASHBOARD_PAGE.TOTAL_CALLERS' | translate }}</p>
        </div>
        <div><i class="fas fa-user card-icon"></i></div>
      </div>
    </div>

    <div class="col-md-4 col-lg-4">
      <div class="stat-card">
        <div>
          <h5>{{ dashboardData.totalRecordedCalls || 0 }}</h5>
          <p>{{ 'DASHBOARD_PAGE.RECORDED_CALLS' | translate }}</p>
        </div>
        <div><i class="fas fa-phone card-icon"></i></div>
      </div>
    </div>

    <div class="col-md-4 col-lg-4">
      <div class="stat-card">
        <div>
          <h5>{{ dashboardData.openDisputes || 0 }}</h5>
          <p>{{ 'DASHBOARD_PAGE.OPEN_DISPUTES' | translate }}</p>
        </div>
        <div><i class="fas fa-comment card-icon"></i></div>
      </div>
    </div>

    <div class="col-md-4 col-lg-4">
      <div class="stat-card">
        <div>
          <h5>{{ dashboardData.totalTalkingBuddies || 0 }}</h5>
          <p>{{ 'DASHBOARD_PAGE.TOTAL_TALKING_BUDDIES' | translate }}</p>
        </div>
        <div><i class="fas fa-user card-icon"></i></div>
      </div>
    </div>

    <div class="col-md-4 col-lg-4">
      <div class="stat-card">
        <div>
          <h5>{{ dashboardData.totalCalls || 0 }}</h5>
          <p>{{ 'DASHBOARD_PAGE.TOTAL_CALLS' | translate }}</p>
        </div>
        <div><i class="fas fa-phone card-icon"></i></div>
      </div>
    </div>

    <div class="col-md-4 col-lg-4">
      <div class="stat-card">
        <div>
          <h5>{{ dashboardData.resolvedDisputes || 0 }}</h5>
          <p>{{ 'DASHBOARD_PAGE.RESOLVED_DISPUTES' | translate }}</p>
        </div>
        <div><i class="fas fa-comment card-icon"></i></div>
      </div>
    </div>
  </div>
</div>

<!-- Tables -->
<div
  class="row dashboard-table"
  *ngIf="!isLoading"
  [ngClass]="{ 'collapsed-content': sidebarCollapsed, 'expanded-content': !sidebarCollapsed }"
>
  <div class="col-md-6">
    <h5>
      Users<a href="#/user" class="see-all" title="user-redirection">{{
        'DASHBOARD_PAGE.SEE_ALL' | translate
      }}</a>
    </h5>
    <p-table
      [value]="userItems.length !== 0 ? userItems : noDataRow"
      [paginator]="userItems.length !== 0 ? true : false"
      [rows]="tableParams.PAGE_SIZE"
      tableStyleClass="custom-table"
    >
      <ng-template pTemplate="header" class="table-head">
        <tr>
          <th>{{ 'DASHBOARD_PAGE.USERS_TABLE.NAME' | translate }}</th>
          <th>{{ 'DASHBOARD_PAGE.USERS_TABLE.MOBILE_NUMBER' | translate }}</th>
          <th>{{ 'DASHBOARD_PAGE.USERS_TABLE.EMAIL_ID' | translate }}</th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-user>
        <tr *ngIf="userItems?.length !== 0" (click)="goToUserDetailsPage(user)" class="user-row">
          <td>{{ formatFullName(user) }}</td>
          <td>{{ user.phoneNumber }}</td>
          <td>{{ user.email }}</td>
          <td class="icon-column" *ngIf="user.avatar !== null">
            <img
              class="user-img"
              [src]="baseApiUrl + user.avatar"
              title="icon-person"
              [alt]="user.firstName"
            />
            <span class="tb-badge" *ngIf="user.userType !== userTypeConstants.CALLER">
              <img
                class="table-avatar-tb-logo"
                src="assets/icons/tb-logo.svg"
                alt="Talking Buddy Badge"
              />
            </span>
            <i
              class="fa fa-chevron-right"
              [ngClass]="{
                'with-tb-i': user.userType !== userTypeConstants.CALLER,
                'with-caller-i': user.userType === userTypeConstants.CALLER,
              }"
              aria-hidden="true"
            ></i>
          </td>
          <td class="icon-column" *ngIf="user.avatar === null">
            <img
              class="user-img"
              src="assets/icons/icon-profile.png"
              title="icon-person"
              [alt]="user.firstName"
            />
            <span class="tb-badge" *ngIf="user.userType !== userTypeConstants.CALLER">
              <img
                class="table-avatar-tb-logo"
                src="assets/icons/tb-logo.svg"
                alt="Talking Buddy Badge"
              />
            </span>
            <i
              class="fa fa-chevron-right"
              [ngClass]="{
                'with-tb-i': user.userType !== userTypeConstants.CALLER,
                'with-caller-i': user.userType === userTypeConstants.CALLER,
              }"
              aria-hidden="true"
            ></i>
          </td>
        </tr>
        <tr *ngIf="userItems?.length === 0">
          <td colspan="4" class="no-data-available">
            {{ 'COMMON.NO_AVAILABLE' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div class="col-md-6">
    <h5>
      {{ 'MENU_ITEMS.DISPUTES' | translate }}
      <a href="#/dispute" class="see-all" title="dispute-redirection">{{
        'DASHBOARD_PAGE.SEE_ALL' | translate
      }}</a>
    </h5>
    <p-table
      [value]="disputeItems.length !== 0 ? disputeItems : noDataRow"
      [paginator]="disputeItems.length !== 0 ? true : false"
      [rows]="tableParams.PAGE_SIZE"
      tableStyleClass="custom-table"
    >
      <ng-template pTemplate="header" class="table-head">
        <tr>
          <th>{{ 'DASHBOARD_PAGE.DISPUTES_TABLE.DATE' | translate }}</th>
          <th>{{ 'DASHBOARD_PAGE.DISPUTES_TABLE.RAISED_BY' | translate }}</th>
          <th>{{ 'DASHBOARD_PAGE.DISPUTES_TABLE.DISPUTE_TYPE' | translate }}</th>
          <th>{{ 'DASHBOARD_PAGE.DISPUTES_TABLE.CALL_ID' | translate }}</th>
          <th>{{ 'DASHBOARD_PAGE.DISPUTES_TABLE.STATUS' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dispute>
        <tr *ngIf="disputeItems?.length !== 0">
          <td>
            {{
              dispute?.modifiedOn
                ? (getConvertedDate(dispute.modifiedOn) | date: 'dd-MMM-YYYY')
                : ''
            }}
          </td>
          <td>{{ dispute.raisedByName }}</td>
          <td>{{ dispute.disputeType }}</td>
          <td>{{ dispute.uid }}</td>
          <td>
            <span
              class="badge"
              [ngClass]="{
                'status-success': dispute.disputeStatus === statuses.RESOLVED,
                'status-danger': dispute.disputeStatus === statuses.OPEN,
                'status-warning': dispute.disputeStatus === statuses.UNDER_REVIEW,
                'status-dark': dispute.disputeStatus === statuses.CLOSED,
              }"
            >
              {{ dispute.disputeStatus }}
            </span>
          </td>
        </tr>
        <tr *ngIf="disputeItems?.length === 0">
          <td colspan="5" class="no-data-available">
            {{ 'COMMON.NO_AVAILABLE' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
